'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherArrowRight, FeatherChevronRight, FeatherGavel, FeatherHeartHandshake, FeatherMail, FeatherMessageSquare, FeatherScale } from '@subframe/core';
import { useRouter } from 'next/navigation';
import React from 'react';
import { Badge, Separator } from '@/shared/components/ui';
type AcoesRapidasVariant = 'lista' | 'grade';
interface AcaoRapida {
  id: string;
  icon: React.ReactNode;
  titulo: string;
  descricao: string;
  rota?: string;
  emBreve?: boolean;
  bgClass: string;
  iconClass: string;
}
interface Props {
  variant?: AcoesRapidasVariant;
}
const ACOES_RAPIDAS: ReadonlyArray<AcaoRapida> = [{
  id: 'nova-notificacao',
  icon: <FeatherMail />,
  titulo: 'Nova notificação',
  descricao: 'Enviar aviso a um devedor',
  rota: '/notificacoes',
  bgClass: 'bg-brand-50',
  iconClass: 'text-brand-600'
}, {
  id: 'nova-negociacao',
  icon: <FeatherMessageSquare />,
  titulo: 'Nova negociação',
  descricao: 'Iniciar tratativa com IA',
  rota: '/negociacoes',
  bgClass: 'bg-success-50',
  iconClass: 'text-success-600'
}, {
  id: 'nova-mediacao',
  icon: <FeatherHeartHandshake />,
  titulo: 'Nova mediação e conciliação',
  descricao: 'Iniciar tratativa de acordo',
  emBreve: true,
  bgClass: 'bg-brand-50',
  iconClass: 'text-brand-600'
}, {
  id: 'novo-processo-arbitral',
  icon: <FeatherScale />,
  titulo: 'Novo processo arbitral',
  descricao: 'Protocolar um processo',
  rota: '/arbitral/novo',
  bgClass: 'bg-warning-50',
  iconClass: 'text-warning-700'
}, {
  id: 'nova-peticao',
  icon: <FeatherGavel />,
  titulo: 'Nova petição',
  descricao: 'Incluir documento processual',
  emBreve: true,
  bgClass: 'bg-neutral-100',
  iconClass: 'text-neutral-600'
}];
export function AcoesRapidas(t0) {
  const $ = _c(6);
  const {
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "lista" : t1;
  const router = useRouter();
  let t2;
  if ($[0] !== router) {
    t2 = acao => {
      if (acao.emBreve || !acao.rota) {
        return;
      }
      router.push(acao.rota);
    };
    $[0] = router;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleAcaoClick = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex flex-col gap-1 border-b border-neutral-100 px-4 py-3"><span className="text-default-font text-base font-semibold">Ações rápidas</span><span className="text-subtext-color text-xs">Comece em um clique.</span></div>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== handleAcaoClick || $[4] !== variant) {
    t4 = <div className="flex h-full flex-col overflow-hidden rounded-[16px] border border-neutral-200 bg-white">{t3}{variant === "grade" ? <div className="grid grid-cols-2 gap-3 p-3 sm:grid-cols-3 lg:grid-cols-5">{ACOES_RAPIDAS.map(acao_0 => <button key={acao_0.id} type="button" onClick={() => handleAcaoClick(acao_0)} disabled={acao_0.emBreve} className={`group hover:border-brand-200 flex min-w-0 flex-col gap-2 rounded-[16px] border border-neutral-200 p-3 text-left transition-all ${acao_0.emBreve ? "cursor-not-allowed opacity-60" : "cursor-pointer hover:shadow-sm"}`}><div className="flex items-center justify-between"><div className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${acao_0.bgClass} ${acao_0.iconClass}`}>{acao_0.icon}</div>{acao_0.emBreve ? <Badge variant="warning" className="h-auto px-1.5 py-0 text-[10px]">Em breve</Badge> : <FeatherArrowRight className="group-hover:text-brand-600 h-4 w-4 text-neutral-400 transition-transform group-hover:translate-x-1" />}</div><div className="flex flex-col gap-0.5"><span className="text-default-font text-sm font-semibold">{acao_0.titulo}</span><span className="text-subtext-color text-xs">{acao_0.descricao}</span></div></button>)}</div> : <div className="flex flex-col py-2">{ACOES_RAPIDAS.map((acao_1, index) => <React.Fragment key={acao_1.id}><button type="button" onClick={() => handleAcaoClick(acao_1)} disabled={acao_1.emBreve} className={`flex items-center gap-3 px-4 py-2.5 text-left transition-colors ${acao_1.emBreve ? "cursor-not-allowed opacity-60" : "cursor-pointer hover:bg-neutral-50"}`}><div className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-[10px] ${acao_1.bgClass} ${acao_1.iconClass}`}>{acao_1.icon}</div><div className="flex min-w-0 flex-1 flex-col"><div className="flex items-center gap-2"><span className="text-default-font truncate text-sm font-semibold">{acao_1.titulo}</span>{acao_1.emBreve && <Badge variant="warning" className="h-auto px-1.5 py-0 text-[10px]">Em breve</Badge>}</div><span className="text-subtext-color truncate text-xs">{acao_1.descricao}</span></div>{!acao_1.emBreve && <FeatherChevronRight className="h-4 w-4 shrink-0 text-neutral-300" />}</button>{index < ACOES_RAPIDAS.length - 1 && <Separator />}</React.Fragment>)}</div>}</div>;
    $[3] = handleAcaoClick;
    $[4] = variant;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}